import React from "react";
import { Layout, Row, Col, Typography, Space, Avatar, Dropdown, Menu, Modal } from 'antd';
import {UserOutlined,LogoutOutlined,QuestionCircleOutlined,BellOutlined,ExclamationCircleOutlined} from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { routes } from '../../routes/Routes';

const { Header } = Layout;
const { Text } = Typography;
const { confirm } = Modal;

const ShowApplicationId = () => {
    const applicationId = localStorage.getItem("ApplicationId");
    const history = useHistory();

    const showLogoutConfirm = () => {
        confirm({
            title: `Are you sure you want to Logout?`,
            icon: <ExclamationCircleOutlined />,
            okText: <span id="yesBtn">Yes</span>,
            cancelText: <span id="noBtn">No</span>,
            okType: "primary",
            onOk() {
                onLogoutOkClick();
            },
        });
    };

    const onLogoutOkClick = async () => {
        localStorage.clear();
        window.sessionStorage.clear();
        history.push(routes.registeredEmail.path);
    };

    const menu = (
        <Menu>
            <Menu.Item key="logout" icon={<LogoutOutlined style={{ transform: 'rotate(-90deg)' }} />} onClick={showLogoutConfirm}>
                Logout
            </Menu.Item>
        </Menu>
    );
    return (
        <>

            <Row
                align="middle"
                justify="end"
                style={{ width: '100%'}}
            >
                <Col
                    xs={24}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end', // Right-align the content
                        paddingRight: 24,
                    }}
                >
                    <Space size="middle">
                        <div className="fRight baseAlign">
                            <strong className="f16">Application ID:</strong>
                            <span className="ml5 f16">{applicationId ? applicationId : "N/A"}</span>
                        </div>

                        <Dropdown overlay={menu} placement="bottomRight">
                            <Space className="applicantLogOutBtn f16" style={{ color: "#fff", cursor: "pointer" }}>
                                <Avatar
                                    size="small"
                                    icon={<LogoutOutlined style={{ transform: 'rotate(-90deg)' }}/>}
                                    style={{ backgroundColor: "#fff", color: "#193a6a" }}
                                />
                                Logout
                            </Space>
                        </Dropdown>
                        
                    </Space>
                </Col>
            </Row>

        </>

    );
}

export default ShowApplicationId;